import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Mail, Code2, Heart } from "lucide-react";

const footerLinks = {
  main: [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Skills", path: "/skills" },
    { label: "Projects", path: "/projects" },
    { label: "Services", path: "/services" },
  ],
  resources: [
    { label: "Components", path: "/components" },
    { label: "Blog", path: "/blog" },
    { label: "Contact", path: "/contact" },
    { label: "Hiring Guide", path: "/blog/hire-react-native-developer-pakistan-2026" },
    { label: "App Cost Guide", path: "/blog/react-native-app-cost-2026" },
  ],
};

const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/irfanquttab1",
    icon: Github,
    label: "Visit GitHub Profile",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/irfanquttab",
    icon: Linkedin,
    label: "Connect on LinkedIn",
  },
  {
    name: "Twitter",
    url: "https://x.com/irfanquttab",
    icon: Twitter,
    label: "Follow on Twitter",
  },
  {
    name: "Email",
    url: "mailto:irfanquttab@gmail.com",
    icon: Mail,
    label: "Send an Email",
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <Code2 className="w-6 h-6 text-primary group-hover:text-accent transition-colors" />
              <span className="text-lg font-bold font-mono text-foreground">
                {"<RN.Dev />"}
              </span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Expert React Native developer building high-performance mobile and
              desktop applications for iOS, Android, and beyond.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target={social.name !== "Email" ? "_blank" : undefined}
                    rel={social.name !== "Email" ? "noopener noreferrer" : undefined}
                    className="text-muted-foreground hover:text-primary transition-colors"
                    aria-label={social.label}
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Main Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Navigation</h3>
            <ul className="space-y-2">
              {footerLinks.main.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Resources</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Get In Touch</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a
                  href="mailto:irfanquttab@gmail.com"
                  className="hover:text-primary transition-colors"
                >
                  irfanquttab@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+923306949000"
                  className="hover:text-primary transition-colors"
                >
                  +92 330 694 9000
                </a>
              </li>
              <li>Lahore (in-person) • Remote worldwide</li>
              <li className="pt-2">
                <Link
                  to="/contact"
                  className="text-primary hover:underline font-medium"
                >
                  Contact Form →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Irfan Qutab. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              Built with <Heart className="w-4 h-4 text-red-500 fill-current" />{" "}
              using React & TypeScript
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
